// Copyright (c) StrangeBee 2023

import { CommentController } from 'thehive-sdk';

interface CommentEventListOutPut {
    onCreate: (st: string) => void;
    onDelete: (commentId: string) => void;
    onUpdate: (txt: string, commentId: string) => void;
}

interface CommentEventListProps {
    controller: CommentController;
    onSuccess?: () => void;
    onError?: (label?: string) => void;
    objectId: string;
    parentType: 'case' | 'alert';
}

export const computeEventList = ({
    controller,
    onError,
    onSuccess,
    objectId,
    parentType,
}: CommentEventListProps): CommentEventListOutPut => ({
    onCreate: (txt: string) => {
        controller
            .createOnParent({ message: txt }, parentType, objectId)
            .then(() => {
                onSuccess?.();
            })
            .catch(onError);
    },

    onDelete: (commentId: string) => {
        controller
            .delete(commentId)
            .then(() => {
                onSuccess?.();
            })
            .catch(onError);
    },

    onUpdate: (txt: string, commentId: string) => {
        controller
            .edit({ message: txt }, commentId)
            .then(() => {
                onSuccess?.();
            })
            .catch(onError);
    },
});
